//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import utils from '@/utils/utils';

export default {
  name: 'video-player',
  props: {
    sourceSrc: String,
  },
  data(){
    return {
      isShowFullScreen: false,    // 显示全屏播放器
      isShowCloseBar: false,      // 显示关闭播放器按钮栏
    };
  },
  watch: {
    sourceSrc(newSrc){
      if(newSrc){
        this.isShowFullScreen = true;
      }
    }
  },
  methods: {
    /** 视频加载中 */
    onLoadStart(){
      this.$vux.loading.show();
    },

    /** 视频播放中 */
    onPlayVideo(){
      this.$vux.loading.hide();

      if(utils.getSystem() === 'Android'){
        document.getElementById('fullScreenPlayer').play();
      }
    },

    /** 显示关闭栏 */
    onClickVideo(){
      let timer = null;

      this.isShowCloseBar = !this.isShowCloseBar;
      timer = setTimeout(() => {
        clearTimeout(timer);
        this.isShowCloseBar = false;
      }, 3000);
    },

    /** 关闭全屏播放器 */
    onClosePlayer(){
      this.isShowFullScreen = false;
      this.$emit('on-close-player');
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/VideoPlayer.vue